<template name="invisitListSecurity">
  <div class="security-invite-list">
    <div class="main-content invite-list">
      <div class="block-header">
        <div class="row">
          <div class="col-12 col-md-3">
            <h2 class="block-title">全部邀请</h2>
          </div>
          <div class="col-12 col-md-9">
            <div class="row">
              <div class="col-md-5 form-item-search">
                <i class="iconfont icon-search"></i>
                <input type="text" name="key" class="form-control" placeholder="输入关键词搜索" v-model="keywords">
                <i class="iconfont icon-close clear-input" @click="clearInput" v-show="keywords.trim().length"></i>
              </div>
              <div class="col-md-5 form-item-date">
                <i class="iconfont icon-clock" @click="showStartDate=true"></i>
                <div class="date-group form-control">
                  <div class="item start-date">
                    <input
                      type="text"
                      class="form-control is-editable"
                      placeholder="yyyy/mm/dd"
                      v-model="startDate"
                      id="my-custom-editable-input">
                    <date-picker color="#f40009"
                      v-model="startDate"
                      locale="en"
                      format="YYYY/MM/DD"
                      element="my-custom-editable-input"
                      :editable="true"
                      :show="showStartDate"
                      @close="closeStartDate">
                    </date-picker>
                  </div>
                  <div class="item date-to">至</div>
                  <div class="item end-date">
                    <input
                      type="text"
                      class="form-control is-editable"
                      placeholder="yyyy/mm/dd"
                      v-model="endDate"
                      id="my-custom-editable-input">
                    <date-picker color="#f40009"
                      v-model="endDate"
                      locale="en"
                      format="YYYY/MM/DD"
                      element="my-custom-editable-input"
                      :min="startDate"
                      :editable="true"
                      :show="showEndDate"
                      @close="showEndDate=false">
                    </date-picker>
                  </div>
                </div>
              </div>
              <div class="search-btn col-md-2">
                <button class="btn" @click="getInviteList()">搜索</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-content">
        <div class="data-list">
          <div class="no-list" v-if="!visitList.length" v-show="!isLoading">
            <div class="inner" v-if="searched">
              <img src="../assets/images/search-no-result@2x.png" class="icon">
              <h5>暂无搜索结果</h5>
            </div>
            <div class="inner" v-else>
              <img src="../assets/images/no-result@2x.png" class="icon">
              <h5>列表暂无邀请</h5>
              <p>暂时还没有任何邀请信息哦</p>
            </div>
          </div>
          <ul>
            <li v-for="(item, index) in visitList">
              <router-link :to="'/security/detailList/' + item.ticketId">
                <div class="top row">
                  <div class="col-9">
                    <div class="top">
                      <span class="radius-list" ></span>
                      <span class="title bold">
                        {{item.title}}
                      </span>
                    </div>
                  </div>
                  <div class="col-3 col-count">
                    <div class="row">
                      <div class="count enter">
                        <strong>{{item.visitorEnterNumber}}</strong>
                        <span>到访</span>
                      </div>
                      <div class="count in-park">
                        <strong>{{item.visitorInParkNumber}}</strong>
                        <span>在访</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bottom row">
                  <div class="col shenfenzheng">
                    <i class="iconfont icon-shenfenzheng"></i>
                    <span>{{item.createUserName}}</span>
                  </div>
                  <div class="col renyuanguanli">
                    <i class="iconfont icon-renyuanguanli"></i>
                    <span>{{item.visitorNumber}}人</span>
                  </div>
                  <div class="col business">
                    <i class="iconfont icon-business"></i>
                    <span>{{item.visitorTypeName}}</span>
                  </div>
                  <div class="col time">
                    <i class="iconfont icon-clock"></i>
                    <span>{{item.startTime}} - {{item.endTime}}</span>
                  </div>
                  <div class="col car" v-if="item.carNumber">
                    <i class="iconfont icon-car"></i>
                    <span>{{item.carNumber}}</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script>
import { securityTodayInvitelist } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import myAuth from '@/utils/auth';

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'invisitListSecurity',
  components: {
    datePicker: VuePersianDatetimePicker,
    Loading,
  },
  props: {
    postID: Number,
  },
  data() {
    return {
      keywords: '',
      date: '',
      visitList: [],
      isLoading: false,
      searched: false,
      searchbtn: false,
      startDate: '',
      endDate: '',
      showStartDate: false,
      showEndDate: false,
    }
  },
  created: function () {
    this.getInviteList();
  },
  watch: {
    postID: function() {
      if (myAuth.checkToken()) {
        myAuth.getRefreshAccessToken().then((model) => {
          myAuth.setLocalAccessToken(model);
          this.getInviteList();
        });
      } else {
        this.getInviteList();
      }
    },
  },
  methods: {
    clearInput() {
      this.keywords = '';
      this.getInviteList();
    },
    bindData(res) {
      const t = this;
      if (checkNested(res, 'data', 'content', 'model')) {
        t.visitList = res.data.content.model;
      }
    },
    getInviteList() {
      this.isLoading = true;
      this.searched = this.keywords === '' ? false : true;
      securityTodayInvitelist(this.keywords).then((res) => {
        this.isLoading = false;
        this.bindData(res);
      });
    },
    closeStartDate() {
      this.showStartDate = false;
      setTimeout(() => {
        this.showEndDate = true;
      }, 500)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.security-invite-list {
  padding: 30px 0 30px 30px;
}
.invite-list {
  background: #fff;
  padding: 15px 0;
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }
  .block-header {
    padding: 12px 0;
    & > .row {
      justify-content: space-between;
    }
    .block-title {
      font-size: 18px;
      font-weight: bold;
      & + .icon-close {
        position: absolute;
        line-height: 21px;
        font-size: 18px;
        top: 0;
        right: 15px;
        display: none;
        cursor: pointer;
      }
    }
    .col-12 {
      position: relative;
    }
    .iconfont {
      position: absolute;
      top: 0;
      line-height: 26px;
      color: #999;
      font-size: 14px;
    }
    .icon-search {
      left: 20px;
    }
    .icon-clock {
      right: 8px;
    }
    .inner {
      width: 90%;
      padding: 10px 0;
      margin: 0 auto;
    }
    .form-control {
      height: 26px;
      font-size: 12px;
      border-color: #dfdfdf;
    }
    .form-item-search {
      .form-control {
        padding-left: 28px;
      }
    }
    .form-item-date {
      .form-control {
        padding-right: 28px;
        padding-left: 8px;
      }
    }
    .clear-input {
      position: absolute;
      right: 25px;
      top: 10px;
      width: 18px;
      height: 18px;
      background-color: #9b9b9b;
      border-radius: 100%;
      color: #fff;
      line-height: 18px;
      text-align: center;
      cursor: pointer;
    }
    .search-btn {
      padding-left: 0;
      .btn {
        color: #e42029;
        display: block;
        width: 100%;
        font-size: 13px;
        line-height: 24px;
        padding: 0;
        border: 1px solid #e42029;
      }
    }
    .date-to {
      color: #929292;
    }
    .date-group {
      display: flex;
      padding-top: 0;
      padding-bottom: 0;
      line-height: 24px;
      .form-control {
        border: 0;
        height: 24px;
        padding: 0;
        text-align: center;
      }
    }
    .col-md-9 {
      max-width: 500px;
      .col-md-5 {
        padding-right: 0;
        padding-left: 12px;
      }
      .col-md-2 {
        padding-left: 12px;
      }
    }
  }
  .block-content {
    margin-top: 20px;
    .col-md-9 {
      padding: 0;
    }
  }
}
.data-list {
  padding-top: 20px;
  ul {
    margin: 0 auto;
    padding: 0;
    li {
      list-style: none;
      margin-bottom: 15px;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 3px 20px rgba(100, 100, 100, 0.12);
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  a {
    display: block;
    padding: 12px 20px;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
  .top {
    align-items: center;
    .radius-list {
      display: inline-block;
      margin-right: 7px;
      vertical-align: middle;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #ff2137;
      border: 3px solid #ffe2ef;
    }
    .title {
      font-size: 14px;
      color: #212529;
      font-weight: bold;
    }
  }
  .col-count {
    font-size: 12px;
    word-break: break-word;
    .row {
      justify-content: flex-end;
      margin-right: 10px;
    }
    .enter {
      margin-right: 18px;
    }
    strong {
      font-size: 18px;
      color: #e42029;
      margin-right: 6px;
    }
    span {
      color: #4a4a4a;
    }
  }
  .bottom {
    padding-top: 5px;
    margin: 0;
    .col {
      padding: 0 8px 0 0;
      width: auto;
      flex-basis: auto;
      flex-grow: inherit;
    }
    i {
      font-size: 14px;
      color: #e42029;
    }
    span {
      font-size: 12px;
      color: #929292;
      padding-left: 5px;
    }
  }
}
.no-list {
  padding-top: 60px;
  text-align: center;
  .icon {
    width: 86px;
    height: 86px;
    margin: 0 auto 15px;
  }
  h5,
  p {
    font-size: 13px;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 125px;
    height: 42px;
    font-size: 15px;
    line-height: 28px;
    color: #fff !important;
    margin-top: 5px;
    padding: 6px 12px !important;
    display: inline-block !important;
    background-image: linear-gradient(69deg, #f36443, #e42029) !important;
    &:focus,
    &:hover {
      box-shadow: none;
    }
  }
}
</style>
